export default "__VITE_ASSET__C8fIu5j7__"